import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Fade from '@mui/material/Fade';

export default function AccordionTransition() {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <div>
      {/* FAQ Accordion */}
      <Accordion
        expanded={expanded}
        onChange={handleExpansion}
        slots={{ transition: Fade }}
        slotProps={{ transition: { timeout: 400 } }}
        sx={[
          {
            backgroundColor: "#1C486A",
            marginBottom: '16px',  // Add spacing between accordions
            color: '#fff', // Ensuring text contrast for readability
          },
          expanded
            ? {
                '& .MuiAccordion-region': {
                  height: 'auto',
                },
                '& .MuiAccordionDetails-root': {
                  display: 'block',
                },
              }
            : {
                '& .MuiAccordion-region': {
                  height: 0,
                },
                '& .MuiAccordionDetails-root': {
                  display: 'none',
                },
              },
        ]}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} // White icon for better contrast
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography>What services does KALEIDO International offer?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            KALEIDO provides a wide range of services, including Online Bookkeeping, ICT Solutions, Comprehensive Tax Solutions, Business Registration, Company Secretarial Services, Audit Services, and Legal Services.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          backgroundColor: "#1C486A",
          marginBottom: '16px', // Add spacing between accordions
          color: '#fff',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} // White icon for better contrast
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography>What is KALEIDO's approach to online bookkeeping?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            KALEIDO offers tailored accounting packages that include Accounts Receivable & Payable, Bank Reconciliations, Forex & Taxation, and more. We work with various software such as Xero, QuickBooks, MYOB, SAP, and Oracle to keep your financial data accurate and accessible.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          backgroundColor: "#1C486A",
          marginBottom: '16px', // Add spacing between accordions
          color: '#fff',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} // White icon for better contrast
          aria-controls="panel3-content"
          id="panel3-header"
        >
          <Typography>How can KALEIDO help with ICT services?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            KALEIDO specializes in Software and Web Development, Mobile App Development, Digital Transformation, ERP implementation, and Data Analytics. Our solutions are scalable and customized to support your business growth.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          backgroundColor: "#1C486A",
          marginBottom: '16px', // Add spacing between accordions
          color: '#fff',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} // White icon for better contrast
          aria-controls="panel4-content"
          id="panel4-header"
        >
          <Typography>Do you provide tax solutions for businesses outside Sri Lanka?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Yes, while we offer tailored tax solutions for Sri Lankan clients, we also assist international businesses in navigating local tax regulations in their respective markets.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          backgroundColor: "#1C486A",
          marginBottom: '16px', // Add spacing between accordions
          color: '#fff',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} // White icon for better contrast
          aria-controls="panel5-content"
          id="panel5-header"
        >
          <Typography>Can KALEIDO help with starting a business?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Absolutely. KALEIDO offers comprehensive business registration services, helping entrepreneurs streamline the setup process, manage compliance, and ensure successful registrations globally, including in the UK, Australia, Canada, and more.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          backgroundColor: "#1C486A",
          marginBottom: '16px', // Add spacing between accordions
          color: '#fff',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} // White icon for better contrast
          aria-controls="panel6-content"
          id="panel6-header"
        >
          <Typography>What kind of audit services does KALEIDO provide?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            We conduct both external and internal audits for Sri Lankan businesses. Our audits ensure financial accuracy, compliance, and transparency, supporting businesses in maintaining their financial integrity.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          backgroundColor: "#1C486A",
          marginBottom: '16px', // Add spacing between accordions
          color: '#fff',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} // White icon for better contrast
          aria-controls="panel7-content"
          id="panel7-header"
        >
          <Typography>How does KALEIDO assist with legal services?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            KALEIDO provides corporate legal services, including agreement preparation, trademark registration, mergers & acquisitions, corporate governance, and dispute resolution, ensuring your business is legally compliant and protected.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          backgroundColor: "#1C486A",
          marginBottom: '16px', // Add spacing between accordions
          color: '#fff',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} // White icon for better contrast
          aria-controls="panel8-content"
          id="panel8-header"
        >
          <Typography>What industries does KALEIDO's co-founder expertise cover?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Puraveen Yogarasa and Lalidaran Ramasamy, KALEIDO's co-founders, have extensive experience across industries like Fintech, IT, Travel, Retail, and more, with strong financial management and strategic leadership backgrounds.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          backgroundColor: "#1C486A",
          marginBottom: '16px', // Add spacing between accordions
          color: '#fff',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} // White icon for better contrast
          aria-controls="panel9-content"
          id="panel9-header"
        >
          <Typography>What makes KALEIDO's services unique?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            KALEIDO emphasizes innovation, strategic partnerships, and customized solutions. We focus on driving growth, enhancing profitability, and providing expert guidance to help businesses thrive in competitive markets.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          backgroundColor: "#1C486A",
          marginBottom: '16px', // Add spacing between accordions
          color: '#fff',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />} // White icon for better contrast
          aria-controls="panel10-content"
          id="panel10-header"
        >
          <Typography>How can I apply for a job at KALEIDO?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Interested candidates can apply by submitting their CV to info@kaleidoint.com. Even if there are no current openings, KALEIDO welcomes talented individuals and may create roles based on expertise and passion.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
